<!-- front/src/app/core/layout/application-layout/dev-tools/dev-tools-panel.component.html -->
<div class="dev-tools-panel">
  <!-- En-tête : environnement actif -->
  <div class="panel-header">
    <span class="font-semibold text-sm">
      Actif :
      <span *ngIf="status?.activeSnapshot">
        {{ status.activeEnvironment || status.activeSnapshot }}
        <span class="text-xs text-gray-500">({{ status.activeSnapshotDate | date: 'dd/MM/yyyy HH:mm' }})</span>
      </span>
      <span *ngIf="!status?.activeSnapshot" class="text-gray-400">Aucun</span>
    </span>
  </div>

  <!-- Utilisateur : substitution d'identité -->
  <div class="panel-section">
    <div class="section-title">Utilisateur</div>

    <div *ngIf="impersonation" class="impersonation-banner">
      <div class="text-xs">
        Connecté en tant que
        <strong>{{ impersonation.targetProfile.firstName }} {{ impersonation.targetProfile.lastName }}</strong>
      </div>
      <button mat-stroked-button class="w-full mt-2" (click)="stopImpersonation()">
        Revenir à {{ impersonation.realProfile.firstName }} {{ impersonation.realProfile.lastName }}
      </button>
    </div>

    <input
      matInput
      placeholder="Rechercher un profil (2 lettres min.)"
      [(ngModel)]="impersonationSearch"
      (ngModelChange)="onImpersonationSearch($event)"
      class="w-full text-sm border rounded px-2 py-1 mt-2"
    />

    <div *ngFor="let candidate of impersonationCandidates" class="snapshot-row">
      <div class="snapshot-info">
        <span class="text-sm">
          {{ candidate.firstName }} {{ candidate.lastName }}
          <span *ngIf="candidate.isPredik" class="text-xs text-gray-500">· Predik</span>
        </span>
        <span class="text-xs text-gray-500">{{ candidate.email }}</span>
      </div>
      <div class="snapshot-actions">
        <button mat-icon-button (click)="impersonate(candidate)" matTooltip="Se connecter en tant que">
          <mat-icon class="text-base">login</mat-icon>
        </button>
      </div>
    </div>

    <div
      *ngIf="impersonationSearch.trim().length >= 2 && impersonationCandidates.length === 0"
      class="text-xs text-gray-400 py-1"
    >
      Aucun profil
    </div>
  </div>

  <!-- Environnements distants -->
  <div class="panel-section">
    <div class="section-title">Environnements distants</div>
    <div class="env-grid">
      <ng-container *ngFor="let env of status?.environments">
        <div class="env-item">
          <button
            mat-stroked-button
            [disabled]="!env.configured || currentOperation"
            [matTooltip]="!env.configured ? 'Connexion non configurée' : 'Pull depuis ' + env.name"
            (click)="pull(env.name)"
            class="env-button"
          >
            {{ env.name }}
          </button>
          <!-- Bouton switch si un snapshot auto existe pour cet env -->
          <button
            *ngIf="env.hasSnapshot"
            mat-icon-button
            [disabled]="currentOperation || status?.activeSnapshot === env.name"
            (click)="switchSnapshot(env.name)"
            matTooltip="Restaurer le snapshot local"
            class="env-switch-button"
          >
            <mat-icon class="text-base">play_arrow</mat-icon>
          </button>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- Snapshots manuels -->
  <div class="panel-section">
    <div class="section-title">Snapshots manuels</div>

    <div *ngIf="manualSnapshots.length === 0" class="text-xs text-gray-400 py-1">Aucun snapshot</div>

    <div *ngFor="let snap of manualSnapshots" class="snapshot-row">
      <div class="snapshot-info">
        <span class="text-sm">{{ snap.name }}</span>
        <span class="text-xs text-gray-500">{{ snap.createdAt | date: 'dd/MM' }}</span>
      </div>
      <div class="snapshot-actions">
        <button mat-icon-button [disabled]="currentOperation" (click)="switchSnapshot(snap.id)" matTooltip="Restaurer">
          <mat-icon class="text-base">play_arrow</mat-icon>
        </button>
        <button
          mat-icon-button
          [disabled]="currentOperation"
          (click)="deleteSnapshot(snap.id, snap.name)"
          matTooltip="Supprimer"
        >
          <mat-icon class="text-base">delete</mat-icon>
        </button>
      </div>
    </div>

    <!-- Création de snapshot -->
    <div *ngIf="!isCreatingSnapshot">
      <button mat-stroked-button [disabled]="currentOperation" (click)="isCreatingSnapshot = true" class="w-full mt-2">
        + Nouveau snapshot
      </button>
    </div>
    <div *ngIf="isCreatingSnapshot" class="flex gap-2 mt-2">
      <input
        matInput
        placeholder="Nom du snapshot"
        [(ngModel)]="newSnapshotName"
        (keyup.enter)="createSnapshot()"
        class="flex-1 text-sm border rounded px-2 py-1"
      />
      <button mat-icon-button (click)="createSnapshot()" [disabled]="!newSnapshotName.trim()">
        <mat-icon>check</mat-icon>
      </button>
      <button mat-icon-button (click)="isCreatingSnapshot = false; newSnapshotName = ''">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Barre de progression -->
  <div *ngIf="currentOperation" class="panel-section">
    <div *ngIf="!currentOperation.error">
      <div class="text-xs text-gray-600 mb-1">
        {{ currentOperation.step }} ({{ currentOperation.progress }}/{{ currentOperation.total }})
      </div>
      <mat-progress-bar mode="determinate" [value]="progressPercent"></mat-progress-bar>
    </div>
    <div *ngIf="currentOperation.error" class="text-xs text-red-600">
      Erreur : {{ currentOperation.error }}
      <button mat-button color="primary" (click)="clearError()" class="text-xs">Fermer</button>
    </div>
  </div>
</div>
